import React, { useState, useRef } from "react";

const OtpInput = ({ name, length, onSubmitOtp }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputs = useRef([]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return; // Only allow numbers

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Focus the next input
    if (element.value && index < length - 1) {
      inputs.current[index + 1].focus();
    }

    // If the OTP is fully entered, submit
    if (newOtp.every((digit) => digit !== "")) {
      onSubmitOtp(name, newOtp.join(""));
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  return (
    <div className="otp-input-container">
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={digit}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputs.current[index] = el)}
          className="otp-input-box"
        />
      ))}
    </div>
  );
};

export default OtpInput;
